function FirstDay() {
   return (
    
      <div className="page-container">
          <h1 className="page-title">First Day at Gothenburg?</h1>

          <div className="page-content">
            <p>
            To be updated!
            </p>

          </div>
        </div>

  );
}
export default FirstDay;